import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getAll } from "./kcabangAPI";

const initialState = {
  value: [],
  loading: false,
  error: null,
  pageNo: 1,
  pageSize: 10,
  totalRecord: 0,
};

export const fetchAll = createAsyncThunk("kcabang/fetchAll", async (payload) => {
  const response = await getAll(payload);
  return response.data;
});

export const kcabangSlice = createSlice({
  name: "kcabang",
  initialState,
  reducers: { resetData: (state) => initialState },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAll.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchAll.fulfilled, (state, action) => {
        state.loading = false;
        state.value = action.payload.data;
        state.pageNo = action.payload.pageNo;
        state.pageSize = action.payload.pageSize;
        state.totalRecord = action.payload.totalRecord;
      });
  },
});

export const { resetData } = kcabangSlice.actions;

export const selectData = (state) => state.kcabang.value;
export const selectLoading = (state) => state.kcabang.loading;
export const selectError = (state) => state.kcabang.error;
export const selectPageNo = (state) => state.kcabang.pageNo;
export const selectPageSize = (state) => state.kcabang.pageSize;
export const selectTotalRecord = (state) => state.kcabang.totalRecord;

export default kcabangSlice.reducer;
